import Vue from 'vue'

window.vueBus = new Vue()

export default vueBus
